<template>
	<div class="live-place">
		<div class="live-item" v-for="(item,index) in meetingsPlace" :key="index" @click="switchMeetingPlace(item.id,item.meeting_id)" :style="{'clear':(index%2==0?'both':'')}">
			<div class="image">
			<img :src="item.banner" alt="" class="bgCover"  onerror="common.imgError(2,event)" v-if="item.banner">
			<div class="small-icon">
				<img  v-if="item.live_status==2" src="../../assets/images/System/record_icon.png">
				<img  v-else src="../../assets/images/System/live_icon.png">
			</div>
			</div>
			<h1 class="line-clamp-2">{{item.daily_preview_title?item.daily_preview_title:item.name}}</h1>
			<p class="time">
				<van-icon name="clock-o" />
				<span>{{item.start_at}}</span>
			</p>
		</div>
	</div>
</template>
<script>
	export default{
		props:['meetingsPlace'],
		data(){
			return{

			}
		},
		mounted(){
			this.meetingsPlace.forEach((item,index)=>{
				var startTime=(item.start_at.split(' ')[1]).split(':')
				item.start_at=item.start_at.split(' ')[0]+' '+startTime[0]+':'+startTime[1];
			})
		},
		watch:{
			'$route'(to, from) {
		        this.$router.go(0);
			 },
			
		},
		methods:{
			//切换会场
			switchMeetingPlace(id,meeting_id){
				this.$router.push({
					path:'/meeting/live',
					query:{
						id:id,
						meeting_id:meeting_id
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.live-place{
		margin:0 10px;
		.live-item{
			width:46%;
			float:left;
			border:1px solid rgba(225,225,225,1);
			margin:5px 7px;
            border-radius: 5px;
			h1{
				height:30px;
				line-height:15px;
				padding:0 12px;
				margin:10px 0 5px;
				font-size:13px;
				color:#1a1a1a;
				font-weight:normal;
			}
			.image{
				width: 100%;
				position: relative;
				.bgCover{
				border-radius:5px 5px 0 0;
            	width:100%;
				position: relative;
				}
				.small-icon{
					position: absolute;
					bottom:0;
					right:0;
					img{
						width:45px;
					height: 30px;

					}
				}
           

			}
		
			.time{
				display: flex;
				align-items: center;
				margin:0 auto 5px;
				padding:0 12px;
				color:#848484;
				font-size:12px;
				span{
					margin-left:5px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Meeting/MeetingPlace.vue